// extracted by mini-css-extract-plugin
export default {"modal":"KELoSZAJRv1lkbgweJCk","titleWrapper":"qr8k5B7Fn0z0zPeVW3wU","alert":"snFEhUzWt4OK09rkN3U7"};